var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.945 5.922V8.71H8v3.409h1.945V22.25h3.996V12.12h2.682s.251-1.635.373-3.423h-3.04v-2.33c0-.35.436-.818.867-.818H17V2h-2.96C9.847 2 9.945 5.412 9.945 5.922z",
    fill: "#fff"
  })));
}
export default SvgFacebook;